module.exports = __webpack_public_path__ + "img/short03.02a41ce6.png";